export const tryToGetElementMfName = (e: HTMLElement): string | undefined => {
  const findMf = e.closest('[data-mf-loaded]')
  const potentialMf = findMf as HTMLElement

  return potentialMf?.dataset.mfLoaded ?? undefined
}
